
const CustomChannelProfile = () => {
    return null;
}

export default CustomChannelProfile;